(function () {
    'use strict';

    var bootstrapModule = angular.module('common.bootstrap', ['ui.bootstrap']);

    bootstrapModule.factory('bootstrap.dialog', ['$uibModal', '$templateCache', modalDialog]);

    function modalDialog($uibModal, $templateCache) {
        var service = {
            deleteDialog: deleteDialog,
            confirmationDialog: confirmationDialog,
            informationDialog: informationDialog,
            errorDialog: errorDialog
        };

        $templateCache.put('modalDialog.tpl.html',
            '<div>' +
            '    <div class="modal-header">' +
            '        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()"><i class="fa fa-times"></i></button>' +
            '        <h4 class="modal-title"><i class="fa {{faIcon}}"></i>{{title}}</h4>' +
            '    </div>' +
            '    <div class="modal-body">' +
            '        <p>{{message}}</p>' +
            '    </div>' +
            '    <div class="footer-end">' +
            '        <button class="btn btn-danger" ng-if="cancelText.length > 1 && addCancel" ng-click="cancel()">{{cancelText}}</button>' +
            '        <button class="btn {{typeBtnOK}}" ng-click="ok()">{{okText}}</button>' +
            '    </div>' +
            '</div>');

        return service;

        function deleteDialog(itemName) {
            var title = 'Conferma di Cancellazione';
            itemName = itemName || 'record';
            var msg = 'Eliminare ' + itemName + '?';

            return confirmationDialog(title, msg);
        }

        function confirmationDialog(title, msg, okText, cancelText, faIcon, typeBtnOK) {

            var modalOptions = {
                templateUrl: 'modalDialog.tpl.html',
                controller: ModalInstance,
                keyboard: false,
                backdrop: 'static',
                resolve: {
                    options: function () {
                        return {
                            title: title,
                            message: msg,
                            okText: okText,
                            cancelText: cancelText,
                            addCancel: true,
                            faIcon: faIcon,
                            typeBtnOK: 'btn-save'
                        };
                    }
                }
            };

            return $uibModal.open(modalOptions).result;
        }

        function informationDialog(msg) {

            var modalOptions = {
                templateUrl: 'modalDialog.tpl.html',
                controller: ModalInstance,
                keyboard: false,
                backdrop: 'static',
                resolve: {
                    options: function () {
                        return {
                            title: 'Si informa',
                            message: msg,
                            okText: 'OK',
                            cancelText: null,
                            addCancel: false,
                            faIcon: 'fa fa-info'
                        };
                    }
                }
            };

            return $uibModal.open(modalOptions).result;
        }

        function errorDialog(msg) {

            var modalOptions = {
                templateUrl: 'modalDialog.tpl.html',
                controller: ModalInstance,
                keyboard: false,
                backdrop: 'static',
                resolve: {
                    options: function () {
                        return {
                            title: 'Errore',
                            message: msg,
                            okText: 'Ho capito',
                            cancelText: '',
                            addCancel: false,
                            faIcon: 'fa-exclamation',
                            typeBtnOK: 'btn-info'
                        };
                    }
                }
            };

            return $uibModal.open(modalOptions).result;
        }
    }

    var ModalInstance = ['$scope', '$uibModalInstance', 'options',
        function ($scope, $uibModalInstance, options) {
            $scope.title = options.title || 'Title';
            $scope.message = options.message || '';
            $scope.okText = options.okText || 'OK';
            $scope.cancelText = options.cancelText || 'Annulla';
            $scope.addCancel = options.addCancel;
            $scope.faIcon = options.faIcon || 'fa-pencil';
            $scope.typeBtnOK = options.typeBtnOK || 'btn-success';
            $scope.ok = function () { $uibModalInstance.close('ok'); };
            $scope.cancel = function () { $uibModalInstance.dismiss('cancel'); };
        }];
})();